<template>
  <section class="about-chapter-5">
    <div class="footer-wrapper">
      <AboutAnchorNav :section="5" />
      <Footer />

      <img src="@/assets/fes-corn-wave.svg" width="100%" class="footer-corn"/>
    </div>
    <div class="footer-credit text-center">
      <p class="text-body text--fes-blue mb-0">
        This website is designed and implemented by
        <a
          href="http://studio.kontinentalist.com/"
          target="_blank" class="ml-2">
          <img src="@/assets/konti-logo.svg" width="150px" class="mt-4 mt-md-0" style="vertical-align: middle;" />
        </a>          
      </p>      
    </div>
  </section>  
</template>

<script>
import AboutAnchorNav from '@/components/layout/AboutAnchorNav'
import Footer from '@/components/layout/Footer'

export default {
  name: 'AboutChapter6',
  components: {
    AboutAnchorNav,
    Footer,
  },
}
</script>

<style lang="scss" scoped>
.about-chapter-5 {
  scroll-margin-top: 70px;
  background: #E9ECFB;


  div.footer-wrapper {
    position: relative;
    padding: 96px 0;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      padding: 48px 4px;
    }    
  }

  .footer-corn {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 35vw;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      width: 100%;
      position: relative;
      bottom: -48px;
    }    
  }

  .footer-credit {
    background: #DCE1F5;
    padding: 48px 0;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      padding: 32px 4px;
    }      
  }
}
</style>